<template>
  <va-card :title="$t('tables.orders.code') + ' ' + this.$route.params.code">
    <va-button
      v-if="this.$route.params.assemblyLine == 1"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'mounting', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date, 
        loadCode: this.$route.params.loadCode }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 2"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'conferencing', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date, 
        loadCode: this.$route.params.loadCode }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 3"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'stacking', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date, 
        loadCode: this.$route.params.loadCode }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 4"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'layer_picking', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date, 
        loadCode: this.$route.params.loadCode }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 5"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'conference_supervision', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date, 
        loadCode: this.$route.params.loadCode }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 6"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'vehicle_liberation', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date, 
        loadCode: this.$route.params.loadCode }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 7"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'transporting', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date, 
        loadCode: this.$route.params.loadCode }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 8"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'finished', params: {
        current_page: this.$route.params.current_page, 
        searchName: this.$route.params.searchName, 
        perPage: this.$route.params.perPage,
        delivery_date: this.$route.params.delivery_date, 
        loadCode: this.$route.params.loadCode }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button  v-if="this.$route.params.assemblyLine == 9 || this.$route.params.assemblyLine == 10 
    || this.$route.params.assemblyLine == 11 || this.$route.params.assemblyLine == 12"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'lists-load-table', params: { back: this.$route.params.loadId, code: this.$route.params.load, assemblyLine: this.$route.params.assemblyLine, 
        loadCode: this.$route.params.loadCode } }"
    >
      {{ $t('menu.back') }}
    </va-button>

    <va-data-table 
      :fields="fields" 
      :data="data" 
      :per-page="20"
    />
  </va-card>
</template>

<script>
import OrdersAPI from '@/services/OrdersAPI'

export default {
  data () {
    return {
      data: [],
    }
  },
  mounted () {
    let orderId = this.$route.params.orderId
    OrdersAPI.getOrderErrorsByOrder(orderId).then(response => {
      this.data = response.data.order_errors
    })
  },
  methods: {
  },
  computed: {
    fields () {
      return [
        {
          name: 'product_name',
          title: this.$t('tables.order_errors.product_name'),
          width: '10%',
        },
        {
          name: 'box',
          title: this.$t('tables.order_products.box'),
          width: '5%',
        },
        {
          name: 'quantity',
          title: this.$t('tables.order_errors.quantity'),
          width: '5%',
        },
        {
          name: 'error_type_name',
          title: this.$t('tables.order_errors.errors_type_name'),
          width: '10%',
        },
        {
          name: 'informer',
          title: this.$t('tables.order_errors.users_informer'),
          width: '10%',
        },
        {
          name: 'offender',
          title: this.$t('tables.order_errors.users_offender'),
          width: '10%',
        },
      ]
    },
  }
}
</script>